
import { PROJECT_ROLE_MANAGER, PROJECT_ROLE_MEMBER, PROJECT_ROLE_PENDING, PROJECT_ROLE_NONE } from '../constants/project_users_roles'

export const isObserver = (observation) => {
  if(!observation){
    return false;
  }
  const sessionData = JSON.parse(localStorage.getItem('sessionData'))
  if (!sessionData || !sessionData.id){
    return false;
  }
  return (sessionData.id === observation.user.id)
}

/*****************
 * Get Project Role & isProjectRole functions will be most performant if moved into a getter or computed field....
 */

/**
 * Get the user's effective role in the project
 * @param {string} projectId - current user's membership info
 * @returns {string} - returns role
 */
const getProjectRole = (projectId) => {
  if(!projectId){
    return PROJECT_ROLE_NONE
  }
  //ToDo: store sessionData in VUEX
  const sessionData = JSON.parse(localStorage.getItem('sessionData'))
  if (!sessionData){
    return PROJECT_ROLE_NONE
  }
  const memberships = sessionData.memberships;
  if (!memberships || memberships.length === 0){
    return PROJECT_ROLE_NONE
  }
  const projectMembership = memberships.find((membership)=>{
    return (projectId === membership.projectId);
  })
  if (projectMembership === undefined){return PROJECT_ROLE_NONE}
  if (!projectMembership.approved){return PROJECT_ROLE_PENDING}
  if (projectMembership.role === PROJECT_ROLE_MEMBER){return PROJECT_ROLE_MEMBER}
  if (projectMembership.role === PROJECT_ROLE_MANAGER){return PROJECT_ROLE_MANAGER}
  console.error("getProjectRole error: invalid project role")
  return PROJECT_ROLE_NONE;
}



/**
 * Check if loggedin user is manager of a given project
 * @param {string} projectId - current user's membership info
 * @returns {boolean} - true if user is manager for the project false otherwise
 */
export const isProjectRoleManager = (projectId) => {
  return getProjectRole(projectId) === PROJECT_ROLE_MANAGER
}

/**
 * Check if loggedin user is member of a given project
 * @param {string} projectId - current user's membership info
 * @returns {boolean} - true if user is manager for the project false otherwise
 */
export const isProjectRoleMember = (projectId) => {
  const projectRole = getProjectRole(projectId)
  return projectRole === PROJECT_ROLE_MEMBER ||
    projectRole === PROJECT_ROLE_MANAGER

}
/**
 * Check if loggedin user is pending membership of a given project
 * @param {string} projectId - current user's membership info
 * @returns {boolean} - true if user is manager for the project false otherwise
 */
export const isProjectRolePending = (projectId) => {
  return getProjectRole(projectId) === PROJECT_ROLE_PENDING
}


/**
 * @function displayRole:
 * @param role
 * @returns {string}
 */
export const displayRole = (role) => {
  if (role === PROJECT_ROLE_MANAGER) {
    return PROJECT_ROLE_MANAGER.charAt(0).toUpperCase() + PROJECT_ROLE_MANAGER.slice(1)
  } else if (role === PROJECT_ROLE_MEMBER) {
    return 'Contributor'
  }
}

